<template>
  <div class="category">

    <div class="mt-5">
      <div class="row">
        <div class="col-12" v-if="!!$slots.pos0">
          <div class="pb-3">
            <slot name="pos0"></slot>
          </div>
        </div>
        <div class="col-6" v-if="!!$slots.pos1">
          <h2 class="card-title mb-3">
            <slot name="pos1-title">Описание</slot>
          </h2>
          <slot name="pos1"></slot>
        </div>
        <div class="col-3"  v-if="!!$slots.pos2">
          <h2 class="card-title mb-3">
            <slot name="pos2-title">Функционал</slot>
          </h2>
          <slot name="pos2"></slot>

        </div>
        <div class="col-3" v-if="!!$slots.pos3">
          <h2 class="card-title mb-3">
            <slot name="pos3-title">Помощь</slot>
          </h2>
          <slot name="pos3"></slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Category"
}
</script>

<style scoped>
.category h2 {
  font-size: 1.4rem;
}

.category h3 {
  font-size: 1.2rem;
}
</style>